import './App.css';
import { FaEnvelope, FaLinkedin, FaTwitter, FaArrowDown, FaCheckCircle, FaCode, FaUsers } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ParticlesBg from 'particles-bg';
import { appsData, getTotalAppsCount } from './appsData';
import { useState, useEffect } from 'react';

function App() {
  const [showPatronus, setShowPatronus] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowPatronus(true);
      setTimeout(() => {
        setShowPatronus(false);
      }, 6500);
    }, 13000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = () => {
    const infoSection = document.querySelector('.info-section');
    if (infoSection) {
      infoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <ParticlesBg type="cobweb" bg={true} color="#00d4ff" num={50} />
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div
            className="logo"
            onClick={() => showPatronus && window.open('https://play.google.com/store/apps/dev?id=9202950421383603840', '_blank')}
            style={{ cursor: showPatronus ? 'pointer' : 'default' }}
          >
            <div className={`logo-flip-container ${showPatronus ? 'flipped' : ''}`}>
              <div className="logo-flip-inner">
                <img src="/profile.png" alt="Süleyman Sezer" className="logo-img logo-front" />
                <img src="/patronus-logo.png" alt="Patronus Studio" className="logo-img logo-back" />
              </div>
            </div>
            <span className="logo-text">{showPatronus ? 'Patronus Studio' : 'Süleyman Sezer'}</span>
          </div>
          <nav className="nav">
            <Link to="/" className="nav-link">Ana Sayfa</Link>
            <Link to="/apps" className="cta-button">Uygulamalar</Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div
            className={`profile-image-container ${showPatronus ? 'spinning' : ''}`}
            onClick={() => showPatronus && window.open('https://play.google.com/store/apps/dev?id=9202950421383603840', '_blank')}
            style={{ cursor: showPatronus ? 'pointer' : 'default' }}
          >
            <div className={`profile-flip-container ${showPatronus ? 'flipped' : ''}`}>
              <div className="profile-flip-inner">
                <img src="/profile.png" alt="Süleyman Sezer" className="profile-image profile-front" />
                <img src="/patronus-logo.png" alt="Patronus Studio" className="profile-image profile-back" />
              </div>
            </div>
          </div>
          <h1 className="hero-title">Ben Süleyman Sezer,</h1>
          <p className="hero-subtitle">Native Android Developer</p>

          {/* Social Media Icons */}
          <div className="social-icons">
            <a href="mailto:hi@iamcodder.com" className="social-icon social-icon-email" aria-label="Email">
              <FaEnvelope />
            </a>
            <a href="https://linkedin.com/in/iamcodder" target="_blank" rel="noopener noreferrer" className="social-icon social-icon-linkedin" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://twitter.com/iamcodder" target="_blank" rel="noopener noreferrer" className="social-icon social-icon-twitter" aria-label="Twitter">
              <FaTwitter />
            </a>
          </div>

          <button className="scroll-button" onClick={scrollToSection}>
            <FaArrowDown />
          </button>
        </div>
      </section>

      {/* Philosophy & Experience Section */}
      <section className="info-section">
        <div className="info-container">
          <div className="info-column">
            <h2 className="section-title">Felsefem</h2>
            <div className="info-list">
              <div className="info-item">
                <FaCheckCircle className="info-icon" />
                <p>Kullanıcı merkezli, özgüsel ve erişilebilir ürünler tasarlamak.</p>
              </div>
              <div className="info-item">
                <FaCheckCircle className="info-icon" />
                <p>Temiz kod prensipleriyle sürdürülebilir ve yüksek performanslı uygulamalar geliştirmek.</p>
              </div>
              <div className="info-item">
                <FaCheckCircle className="info-icon" />
                <p>Sürekli öğrenme ve Android ekosistemindeki en son teknolojileri benimsemek.</p>
              </div>
            </div>
          </div>

          <div className="info-column">
            <h2 className="section-title">Deneyimlerim</h2>
            <div className="info-list">
              <div className="info-item">
                <FaCode className="info-icon" />
                <p>Android Native uygulama geliştirme ve Jetpack Compose odaklı uzmanlık.</p>
              </div>
              <div className="info-item">
                <FaCode className="info-icon" />
                <p>Modern Android mimarileri (MVVM, MVI) ve test odaklı geliştirme deneyimi.</p>
              </div>
              <div className="info-item">
                <FaUsers className="info-icon" />
                <p>Çevik geliştirme süreçlerinde takım çalışmasına yatkınlık ve iletişim becerileri.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="projects-section">
        <h2 className="projects-title">Geliştirdiğim Appler</h2>
        <div className="projects-grid">
          {appsData.slice(0, 3).map((app, index) => (
            <div
              key={index}
              className="project-card"
              onClick={() => app.playStoreUrl && window.open(app.playStoreUrl, '_blank')}
              style={{ cursor: app.playStoreUrl ? 'pointer' : 'default' }}
            >
              <div className="project-image" style={{background: `linear-gradient(135deg, ${app.color} 0%, ${app.color}dd 100%)`}}>
                {app.image.startsWith('/') ? (
                  <img src={app.image} alt={app.name} className="app-icon" />
                ) : (
                  <div className="project-placeholder">{app.image}</div>
                )}
              </div>
              <div className="project-info">
                <h3>{app.name}</h3>
                <p>{app.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-apps">
          <Link to="/apps" className="view-all-button">
            Tüm Uygulamalarıma Git
          </Link>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <h2 className="stats-title">Başarılarım</h2>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">✨</div>
            <p className="stat-label">Deneyim Yılı</p>
            <p className="stat-value">4+</p>
          </div>
          <div className="stat-card">
            <div className="stat-icon">📱</div>
            <p className="stat-label">Geliştirilmiş Uygulama Sayısı</p>
            <p className="stat-value">{getTotalAppsCount()}+</p>
          </div>
          <div className="stat-card">
            <div className="stat-icon">⬇️</div>
            <p className="stat-label">Toplam İndirme</p>
            <p className="stat-value">150K+</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="footer-copyright">© 2024 Süleyman Sezer. Tüm hakları saklıdır.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
